<template>
  <div class="home">
    <div class="container" ref="container">
      <mini-player />
      <search
        class="search"
        v-model="search"
        placeholder="输入「歌名」或「链接」开启搜索"
        @change="searchSong"
        :loading="isLoading"
        focus
      ></search>
      <div class="content" v-if="isLoaded">
        <div class="wrap" ref="musicList">
          <MusicInfo
            class="music-info"
            v-for="(item, i) of list"
            :key="`ori_${i}_${reqId}`"
            :info="item"
          />
          <MusicInfo
            class="music-info"
            v-for="(item, i) of fillList"
            :key="`fill_${i}_${reqId}`"
            :info="item"
          />
          <div v-if="isLoaded && list.length == 0">暂无搜索结果</div>
        </div>
      </div>
    </div>
    <div class="footer">
      <span class="support">
        <span
          class="site"
          v-for="item of siteList"
          :key="item.name"
          :title="item.name"
          :style="{ 'background-image': `url(${item.image})` }"
          @click="openUrl(item.link)"
        ></span>
      </span>
    </div>
  </div>
</template>

<script>
import InstallPage from './install';

export default {
  data() {
    return {
      search: '',
      list: [],
      fillList: [],
      reqId: 1,
      isLoaded: false,
      isLoading: false,
      siteList: [
        {
          name: '网易云',
          image: '/assets/platform/163.png',
          link: 'https://music.163.com',
        },
        {
          name: 'QQ音乐',
          image: '/assets/platform/qqmusic.png',
          link: 'https://y.qq.com',
        },
        {
          name: '百度音乐',
          image: '/assets/platform/taihe.png',
          link: 'https://music.taihe.com',
        },
        {
          name: '酷狗',
          image: '/assets/platform/kugou.png',
          link: 'https://kugou.com',
        },
        {
          name: '酷我',
          image: '/assets/platform/kuwo.png',
          link: 'https://kuwo.cn',
        },
        {
          name: 'Hifini音乐磁场',
          image: '/assets/platform/hifini.png',
          link: 'https://hifini.com',
        },
        {
          name: '咪咕音乐',
          image: '/assets/platform/migu.png',
          link: 'https://music.migu.cn',
        },
      ],
    };
  },
  created() {
    if (window.opener) {
      this.$opener.bind();
    }
  },
  methods: {
    calcFillList() {
      this.$nextTick(() => {
        let width = this.$refs.container.getBoundingClientRect().width;
        let maxWidth = window.innerWidth - 100;

        let count = Math.floor((Math.min(width, maxWidth) - 10) / 210);
        let fill = this.list.length % count;
        let arr = [];
        if (fill > 0) {
          arr = new Array(count - fill).fill();
        }
        this.fillList = arr;

        this.$nextTick(() => {
          this.$refs.musicList.scrollTop = 0;
        });
      });
    },
    async searchByUrl() {
      this.isLoading = true;
      try {
        let { code, data } = await (
          await fetch(`${this.$config.apiUrl}/ex/songparser/find`, {
            method: 'post',
            body: JSON.stringify({
              text: this.search,
            }),
          })
        ).json();
        if (code == 0 && data) {
          this.list = [{ ...data, needParse: false }];
          this.search = `${data.name} ${data.author}`;
        } else {
          this.$toast.warn('未找到可播放资源');
          this.list = [];
          this.search = '';
        }
        this.reqId++;
      } catch (e) {}
      this.isLoading = false;
      if (!this.isLoaded && this.list.length) {
        this.isLoaded = true;
      }
      this.calcFillList();
    },
    async searchSong() {
      if (this.search.match(/http(s)?:\/\//i)) {
        return this.searchByUrl();
      }
      try {
        this.isLoading = true;
        // let key = `${encodeURIComponent(this.search).replace(/%/g, "_")}`;
        // let local = this.$storage.get(key);
        // if (local) {
        //   this.list = local;
        //   this.isLoaded = true;
        //   this.isLoading = false;
        //   this.calcFillList();
        //   return;
        // }
        let { code, data } = await (
          await fetch(
            `${
              this.$config.apiUrl
            }/ex/songparser/search/text/${encodeURIComponent(this.search)}`
          )
        ).json();
        if (code == 0) {
          // this.$storage.set(key, data);
          this.list = data;
        } else {
          // this.$storage.set(key, []);
          this.$toast.warn('未找到可播放资源');
          this.list = [];
        }
        this.reqId++;
        this.isLoading = false;
        if (!this.isLoaded && this.list.length) {
          this.isLoaded = true;
        }
        this.calcFillList();
      } catch (e) {
        this.isLoading = false;
      }
    },
    openUrl(url) {
      window.open(url, '_blank');
    },
  },
};
</script>
<style lang="scss" scoped>
.home {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: #e4ecee;
  .container {
    width: 800px;
    max-width: calc(100vw - 40px);
    margin: 50px auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: calc(100vh - 100px);
    .content {
      flex: auto;
      position: relative;
      width: 100%;
      .wrap {
        position: absolute;
        padding: 20px 0 20px 10px;
        width: 100%;
        height: calc(100% - 50px);
        bottom: 25px;
        left: 0;
        overflow: auto;
        text-align: center;
        .music-info {
          margin-right: 10px;
          margin-bottom: 10px;
          vertical-align: middle;
        }
      }
    }
  }
  .footer {
    position: absolute;
    bottom: 0;
    left: 0;
    padding-top: 20px;
    padding-bottom: 20px;
    width: 100%;
    text-align: center;
    font-size: 12px;
    font-weight: lighter;
    background-color: #e4ecee;
    .support {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      .site {
        display: inline-block;
        width: 20px;
        height: 20px;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        border-radius: 50%;
        margin-right: 10px;
        cursor: pointer;
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
}

@media screen and (max-width: 800px) {
  .home {
    .container {
      .content {
        .wrap {
          padding: 0;
          padding-bottom: 100px;
        }
      }
    }
  }
}
</style>